import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import logo from "../../assets/images/1_logo.jpeg";
import eurologowhite from "../../assets/images/eu_logo_white.png";
import Reset from "./Reset";
import Confirm from "./Confirm";
import Signup from "./Signup";
import theme from "../../theme";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import colors from "../constants/Colors";
import { Carousel, Image } from "antd";
import InfoIcon from "@mui/icons-material/Info";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ClearIcon from "@mui/icons-material/Clear";
import {
  IconButton,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  SwipeableDrawer,
} from "@mui/material";
import About from "../About";
import Contact from "../Contact";
import { Copyright } from "@mui/icons-material";
import eutracker_2logo from "../../assets/images/eutracker_2logo.png";
import { Box as MuiBox } from "@mui/material";
import euroLogo from "../../assets/images/euro.png"; // Import static logo
import rdiuplogo from "../../assets/images/logo-rdiup.webp";

export default function Auth() {
  const [toLogin, setToLogin] = React.useState(true);
  const [toSignUp, setToSignUp] = React.useState(false);
  const [toConfirm, setToConfirm] = React.useState(false);
  const [toReset, setToReset] = React.useState(false);
  const [projects, setProjects] = useState([]);
  const [projectIds, setProjectIds] = useState([]);

  const [staticLogos, setStaticLogos] = useState([
    { src: euroLogo, alt: "Euro Logo" },
    { src: rdiuplogo, alt: "RDIUP Logo" },
  ]);

  const navigate = useNavigate();

  const [stateAbout, setStateAbout] = useState({
    right: false,
  });
  const [stateContact, setStateContact] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => () => {
    setStateAbout({ ...stateAbout, [anchor]: open });
  };

  const toggleDrawerContact = (anchor, open) => () => {
    setStateContact({ ...stateContact, [anchor]: open });
  };

  const actions = [
    {
      icon: <InfoIcon />,
      name: "About",
      onClick: () => toggleDrawer("right", true)(),
    },
    {
      icon: <MailOutlineIcon />,
      name: "Contact",
      onClick: () => toggleDrawerContact("right", true)(),
    },
  ];

  const [displayedText, setDisplayedText] = useState("");
  const fullText = `Login to your EUTRACKER\nAccount`;

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText((prev) => prev + fullText[index]);
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval); // Nettoyage de l'intervalle
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const formData = {
      email: data.get("email"),
      password: data.get("password"),
    };

    try {
      const response = await axios.post(
        " https://eutracker.rdiup.com/v1/user/login/",
        //" https://eutracker.rdiup.com/api/token/",

        formData
      );
      console.log("Login successful:", response.data);

      // Storing tokens and user data
      localStorage.setItem("access_token", response.data.token.access);
      localStorage.setItem("refresh_token", response.data.token.refresh);

      localStorage.setItem("email", response.data.user.email);
      localStorage.setItem("is_admin", response.data.user.is_admin);
      localStorage.setItem(
        "organisation_name",
        Number(response.data.user.partner)
      );
      navigate("/selectProject");

      // Swal.fire({
      //   title: "Success!",
      //   text: "Login successful. Redirecting...",
      //   icon: "success",
      //   confirmButtonText: "OK",
      // }).then(() => {
      //   navigate("/selectProject");
      // });
    } catch (error) {
      //console.error("Login error:", error.response?.data);
      if (!Swal.isVisible()) {
        Swal.fire({
          title: "Error!",
          text: `Login failed: ${
            error.response?.data?.errors?.non_field_errors ||
            "An error occurred"
          }`,
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          backdrop: true,
        });
      }
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await axios.get(
        "https://eutracker.rdiup.com/v1/projects/"
      );
      const data = response.data;
      console.log("init data", data);

      // Extract project IDs from the data (assuming data is an array of objects with 'id')
      const ids = data.map((project) => project.id);
      const idsF = data
        .filter((project) => project.imageURL !== null)
        .map((project) => project.id);
      console.log("idssffff", idsF);
      setProjectIds(idsF); // Store only the IDs in state

      console.log("Project IDs:", ids);

      const storedOrganisationId = parseInt(
        localStorage.getItem("organisation_name"),
        10
      );
      console.log("Stored organisation name:", storedOrganisationId);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const filteredProjectIds = projectIds.filter((id) => id !== 3 && id !== 11);

  const allLogos = [
    ...filteredProjectIds.map((id) => ({
      type: "project",
      src: `https://eutracker-files.s3.eu-west-3.amazonaws.com/projects/${id}_logo.png`,
      alt: `Project ${id} logo`,
    })),
    ...staticLogos,
  ];

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        {/*  Drawer to show About */}
        <SwipeableDrawer
          anchor="right"
          open={stateAbout.right}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
        >
          <Grid style={{ padding: 50 }}>
            <IconButton onClick={toggleDrawer("right", false)}>
              <ClearIcon style={{ cursor: "pointer", color: "#085ca4" }} />
            </IconButton>
            <About />
          </Grid>
        </SwipeableDrawer>
        {/*  Drawer to show Contact */}
        <SwipeableDrawer
          anchor="right"
          open={stateContact.right}
          onClose={toggleDrawerContact("right", false)}
          onOpen={toggleDrawerContact("right", true)}
        >
          <Grid style={{ padding: 50 }}>
            <IconButton onClick={toggleDrawerContact("right", false)}>
              <ClearIcon style={{ cursor: "pointer", color: "#085ca4" }} />
            </IconButton>
            <Contact />
          </Grid>
        </SwipeableDrawer>

        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage:
              'url("/static/images/templates/templates-images/sign-in-side-bg.png")',
            backgroundColor: "#085ca4",
            backgroundSize: "cover",
            backgroundPosition: "left",
            height: "100%",
            position: "relative", // make this to fix logo in the grid
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          > */}
          {/* <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{
                width: "40%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Box> */}
          {/* Logo en haut à gauche */}
          <Box
            sx={{
              position: "absolute",
              top: -50,
              left: 20,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Image src={eutracker_2logo} preview={false} width={"40%"} />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <Grid>
              <Grid>
                <Grid
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    padding: 20,
                  }}
                >
                  <p
                    style={{
                      fontSize: 35,
                      textAlign: "left",
                      fontWeight: 700,
                      color: "white",
                      marginTop: 100,
                      lineHeight: 1.5,
                      whiteSpace: "pre-line",
                    }}
                  >
                    <span style={{ color: "#ffc200", fontSize: 45 }}>
                      {displayedText.slice(0, 5)} {/* Partie "Login" */}
                    </span>
                    {displayedText.slice(5)}{" "}
                    {/* Affiche le reste (retour à la ligne) */}
                  </p>
                  <p
                    style={{
                      textAlign: "left",
                      marginLeft: 5,
                      color: "white",
                      marginTop: 10,
                      marginBottom: 0,
                    }}
                  >
                    A digital space where partners collaborate, track, and
                    report
                    <br />
                    on all communication, dissemination, and exploitation
                    efforts.
                    <br />
                    A freemium service designed to enhance project visibility
                    <br />
                    and coordination.
                  </p>
                  {/* logos slider */}
                  <br />
                  <div
                    style={{
                      padding: "20px",
                      maxWidth: "600px",
                      margin: "0 auto",
                      borderRadius: "12px",
                      overflow: "hidden",
                      zIndex: 10,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {allLogos.length > 0 && (
                      <div
                        style={{
                          width: "100%",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            animation: "marquee 20s linear infinite",
                          }}
                        >
                          {[...allLogos, ...allLogos].map((logo, index) => (
                            <MuiBox
                              key={`${logo.type || "static"}-${
                                logo.src
                              }-${index}`}
                              component="img"
                              src={logo.src}
                              sx={{
                                width: "100px",
                                height: "80px",
                                objectFit: "contain",
                                margin: "0 20px",
                                background: "#fff",
                                borderRadius: "8px",
                                transition: "transform 0.3s ease",
                                "&:hover": {
                                  transform: "scale(1.1)",
                                },
                              }}
                              alt={logo.alt} // Fixed: Use logo.alt
                              onError={(e) => {
                                console.error(
                                  `Failed to load image: ${logo.src}`
                                );
                                e.target.src =
                                  "https://via.placeholder.com/150?text=Logo+Not+Found";
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                    <style>
                      {`
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          div:hover > div {
            animation-play-state: paused;
          }
        `}
                    </style>
                  </div>
                </Grid>
                {/* <Image src={eurologowhite} preview={false} width={'30%'} style={{marginLeft:-290,marginTop:50}} /> */}
              </Grid>
              {/* <Image src={logoEU} sx={{width:'100%',height:'auto',objectFit:"cover"}}/> */}
            </Grid>
          </Box>
        </Grid>
        <p style={{ position: "absolute", bottom: 50, right: 250 }}>
          Copyright RDIUP 2024-2026
        </p>

        {toLogin ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={0}
            square
          >
            <Box
              sx={{
                my: 8,
                mx: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "#1976d2" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography
                variant="h5"
                style={{ fontWeight: "800", color: "#1976d2" }}
              >
                Login
              </Typography>
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  //onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  // onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <Grid container justifyContent={"flex-end"}>
                  <span
                    style={{
                      color: "#085ca4",
                      fontWeight: "400",
                      cursor: "pointer",
                    }}
                    href="#"
                    variant="body2"
                    onClick={() => {
                      setToReset(true);
                      setToLogin(false);
                      setToSignUp(false);
                    }}
                  >
                    {"Forgot Password !"}
                  </span>
                </Grid>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    mb: 2,
                    backgroundColor: "085ca4",
                    color: "#ffff",
                    "&:hover": {
                      backgroundColor: "white",
                      color: "#085ca4",
                    },
                  }}
                >
                  Sign In
                </Button>
                <Grid container justifyContent={"flex-end"}>
                  <Link
                    href="#"
                    variant="body2"
                    onClick={() => {
                      setToSignUp(true);
                      setToLogin(false);
                      setToReset(false);
                    }}
                  >
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Box>
            </Box>
          </Grid>
        ) : toSignUp ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={6}
            square
          >
            <Signup setToLogin={setToLogin} />
          </Grid>
        ) : toReset ? (
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={6}
            square
          >
            <Reset setToLogin={setToLogin} />
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            component={Paper}
            elevation={6}
            square
          >
            <Confirm setToLogin={setToLogin} />
          </Grid>
        )}
        <SpeedDial
          ariaLabel="Options Menu"
          sx={{ position: "absolute", bottom: 16, right: 16 }}
          icon={<SpeedDialIcon />}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={action.onClick}
            />
          ))}
        </SpeedDial>
      </Grid>
    </ThemeProvider>
  );
}
